module.exports = __webpack_public_path__ + "img/usda-logo.ef73afa7.jpg";